module.exports = __webpack_public_path__ + "img/rightArrows.101fd8de.png";